import { useDispatch as ToolkitDispatch } from "react-redux";
import { checkIfRulesAreAccepted } from "utils/helpers/checkIfRulesAreAccepted";
import useAlertModal from "./useAlertModal";
import { useNavigate } from "react-router-dom";
import useNotify from "./useNotify";

export default function useDispatch() {
  const dispatch = ToolkitDispatch();
  const notify = useNotify();
  const alert = useAlertModal();
  const navigate = useNavigate();

  const handleRequest = async (apiCall, successMessage) => {
    try {
      const data = await dispatch(apiCall);
      if (!!data.error) {
        throw data.payload;
      }

      if (successMessage) {
        notify(successMessage, "success");
      }

      return data;
    } catch (error) {
      checkIfRulesAreAccepted({ error, notify, alert, navigate });
      throw error
    }
  };

  return handleRequest;
}
